import { z } from "zod"

// Windows-1252 character validation (same regex as the previous Yup implementation)
// eslint-disable-next-line no-control-regex
const ANSI_STRING_REGEX = /^[\x00-\x7F\xA0-\xFF]+$/

/**
 * Applies latin character validation (Windows-1252) to a Zod string schema.
 * Empty strings are allowed (matching Yup's excludeEmptyString: true behavior).
 *
 * @param schema - A Zod string schema to extend with latin validation
 * @param message - Optional custom error message
 * @returns The schema with latin validation applied
 *
 * @example
 * const nameSchema = latin(z.string().max(35))
 * const optionalSchema = latin(z.string()).nullable()
 */
export function latin<T extends z.ZodString>(schema: T, message = "Must include only latin characters (Windows-1252)") {
  return schema.refine((val) => val === "" || ANSI_STRING_REGEX.test(val), { message })
}

/**
 * Convenience function to create a latin-validated string schema.
 *
 * @example
 * const schema = z.object({
 *   name: latinString().max(35),
 *   company: latinString().nullable(),
 * })
 */
export function latinString(message?: string) {
  return latin(z.string(), message)
}

export { z }
export default z
